export const LINKS = {
  appStore: 'https://apps.apple.com/ru/app/google-authenticator/id388497605',
  googlePlay: 'https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2',
};
